export default {
  v3OfficialTopUpCenterTitle: 'Offizielles Aufladezentrum',
  v3OfficialTopUpCenterKeyword: 'Offizielles Aufladezentrum',
  v3OfficialTopUpCenterDescription: 'Offizielles Aufladezentrum',
  v3SafeAndFast: 'Sicher, risikofrei und sofort gutgeschrieben',
  v3Shop: 'Mall',
  v3ShoppingCart: 'Warenkorb',
  v3MembershipCenter: 'Privilegzentrum (Premium-Mitgliederzentrum)',
  v3Login: 'Login',
  v3Account: 'Konto',
  v3EnterAccountName: 'Kontoname eingeben',
  v3Password: 'Passwort',
  v3EnterPassword: 'Passwort eingeben',
  v3ForgotPassword: 'Passwort vergessen',
  v3EnterUID: 'UID eingeben',
  v3OTP: 'Einmalpasswort',
  v3EnterOTP: 'Bitte gib das Einmalpasswort ein',
  v3SelectTopUpCharacter: 'Auflade-Charakter auswählen',
  v3SelectServer: 'Server wählen',
  v3Confirm: 'Bestätigen',
  v3CharacterNotFound:
    'Wenn du den Charakter nicht finden kannst, versuche zunächst, dich im Spiel mit dem Charakter anzumelden. Melde dich dann auf der Aufladeseite an oder wende dich an den Kundendienst.',
  v3Logout: 'Ausloggen',
  v3SwitchAccount: 'Konto wechseln',
  v3MyCoupons: 'Meine Coupons',
  v3BenefitsCenter: 'Privilegzentrum',
  v3TopUpBenefits: 'Aufladevorteile',
  v3MoreSettings: 'Mehr Einstellungen',
  v3RememberLoginStatus: 'Login-Status speichern',
  v3OrderQuery: 'Bestellungen überprüfen',
  v3ContactCustomerService: 'Kundendienst',
  v3LoginWithApp: 'Per App einloggen',
  v3ChooseOtherLoginMethod: 'Wähle eine alternative Login-Methode aus',
  v3ConnectingToGameApp: 'Verbindung zur Spiel-App',
  v3EnsureGameInstalled:
    'Bitte stelle sicher, dass das Spiel auf diesem Gerät installiert ist. Wenn das Spiel nicht reagiert oder der Login fehlschlägt, aktualisiere das Spiel im App Store auf die neueste Version oder wechsle zu einem anderen Browser.',
  v3OpenGame: 'Spiel starten',
  v3DownloadGame: 'Spiel herunterladen',
  v3UpdateGameIfOpenFails:
    'Wenn das Spiel nicht gestartet werden kann, aktualisiere es bitte im App Store/Google Play auf die neueste Version.',
  v3ClickToDownloadLatestVersion:
    'Alternativ kannst du auf die Schaltfläche „Spiel herunterladen“ klicken, um die neueste Version zu erhalten.',
  v3LoggingIntoOfficialTopUpCenter:
    'Du meldest dich beim Offiziellen Aufladezentrum an.',
  v3CurrentAccount: 'Aktuelles Konto: xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: 'Willkommen beim Offiziellen Aufladezentrum',
  v3OfficialAuthorizedLogin:
    'Offiziell autorisiertes Login. Keine Sicherheitsrisiken.',
  v3TermsOfService: 'Nutzungsbedingungen',
  v3PrivacyPolicy: 'Datenschutzrichtlinie',
  v3ThirdPartySocialAccountDescription:
    'Über Soziale Medien-Konten von Drittanbietern',
  v3BindSocialAccountInGameFirst:
    'Bitte schließe zunächst die Bindung deines Soziale Medien-Kontos im Benutzer Zentrum im Spiel ab und logge dich dann mit dem gebundenen Soziale Medien-Konto ein.',
  v3FirstTopUp15PercentOff:
    'Genieße bis zu 15% Rabatt auf deine erste Aufladung.',
  v3MoreTopUpRebates: 'Weitere Aufladerabatte und Belohnungen.',
  v3LoginToViewOffers: 'Einloggen, um Rabatte anzuzeigen.',
  v3TopUpEnvironmentChecking: 'Aufladeumgebung wird überprüft …',
  v3SafeToUse: 'Sicher und geschützt.',
  v3LimitedTimeBenefits: 'Exklusives, zeitlich begrenztes Angebot',
  v3EventRules: 'Eventregeln',
  v3MoreEvents: 'Mehr Events',
  v3Claim: 'Abholen',
  v3Completed: 'Abgeschlossen',
  v3GoTo: 'Los',
  v3ViewDetails: 'Details zeigen',
  v3RecommendedProducts: 'Empf. Items',
  v3SearchProductName: 'Nach Item-Name suchen',
  v3AllCategories: 'Alle',
  v3PopularSort: 'Top',
  v3PriceAscending: 'Preis ↑',
  v3PriceDescending: 'Preis ↓',
  v3DiamondBonus10Percent: 'Diamant +10%',
  v3YuanbaoBonus10Percent: 'Barren +10%',
  v3ExtraBonus10Percent: 'Bonus: 10%',
  v3FirstTopUpDouble: '1. Aufladung doppelt',
  v3FirstExtraBonus: 'Erstmaliger Bonus',
  v3ProductDetails: 'Produkt-Details',
  v3AddToCart: 'In den Warenkorb',
  v3AddedToCart: 'Zum Warenkorb hinzugefügt',
  v3BuyNow: 'Jetzt kaufen',
  v3NoItemsInCart: 'Noch keine Items im Warenkorb',
  v3SelectedItemsN: 'Ausgewählte Items: (${n})',
  v3RemoveFromCart: 'Vom Warenkorb entfernen?',
  v3Yes: 'Ja',
  v3No: 'Nein',
  v3LimitOnePerPurchase:
    'Es kann jeweils nur ein Exemplar dieses Items erworben werden.',
  v3ItemPrice: 'Item-Preis',
  v3Tax: 'Steuer',
  v3ExtraGift: 'Bonus',
  v3Total: 'Gesamt',
  v3ProceedToPayment: 'Bezahlen',
  v3SelectCoupon: 'Coupon auswählen',
  v3UnavailableCoupons: 'Nicht verwendbare Coupons',
  v3OneCouponPerOrder: 'Ein Coupon pro Bestellung',
  v3DiscountCoupon: 'Rabatt-Coupon',
  v3ThresholdCoupon: 'Abzugs-Coupon',
  v3MinSpendCoupon: 'Verwendbar, wenn der Gesamtpreis über xx USD liegt.',
  v3MaxDiscountCoupon: 'Rabatt bis zu xxxx USD',
  v3LimitedChannel: 'Begrenzt auf bestimmte Kanäle',
  v3AllChannels: 'Verfügbar für alle Kanäle',
  v3SpecificProducts: 'Nur bestimmte Items',
  v3AllProducts: 'Für alle Items',
  v3NotYetTimeToUse: 'Noch nicht verwendbar',
  v3Expired: 'Abgelaufen',
  v3Used: 'Verwendet',
  v3ValidityPeriod: 'Gültigkeit:',
  v3ConfirmUse: 'Bestätigen',
  v3ChangeProduct: 'Item ändern',
  v3ConfirmPaymentOrder: 'Bestellung bestätigen',
  v3StoredValueRole: 'Auflade-Charakter',
  v3TotalNProducts: 'Gesamte Items: ${n}',
  v3SelectPaymentMethod: 'Zahlungsmethode auswählen',
  v3PayNow: 'Jetzt bezahlen',
  v3MorePaymentMethods: 'Weitere Zahlungsmethoden',
  v3NoAvailablePaymentMethodContactSupport:
    'Du findest keine verfügbare Zahlungsmethode? Kontaktiere den Kundendienst.',
  v3AvailableCoupons: 'Verwendbare Coupons',
  v3Extra10Percent: '0.1',
  v3LastSelection: 'Vorherige Wahl',
  v3RecommendedUsage: 'Empfohlen',
  v3PopularChoice: 'Beliebte Wahl',
  v3PaymentSuccess: 'Zahlung abgeschlossen',
  v3PaymentFailure: 'Zahlung fehlgeschlagen',
  v3TopUpFailureMessage:
    'Leider ist das Aufladen fehlgeschlagen. Bitte versuche, deine Bestellung erneut aufzugeben oder kontaktiere den Kundendienst.',
  v3Game: 'Spiel',
  v3UID: 'UID',
  v3OrderNumber: 'Bestellnr.',
  v3ProductContent: 'Item-Details',
  v3ViewProductDetails: 'Item-Details anzeigen',
  v3PaymentMethod: 'Zahlungsmethode',
  v3Complete: 'Abgeschlossen',
  v3TopUpAgain: 'Erneut aufladen',
  v3FriendlyReminderSaveOrderInfo:
    'Erinnerung: Speicher deine Bestelldaten per Screenshot für eine schnellere Bearbeitung.',
  v3RechargeAgain: 'Erneut aufladen',
  v3TransactionInProgress: 'Bearbeitung der Transaktion',
  v3CompletePaymentInChannel:
    'Bitte gehe zum Zahlungskanal, um die Zahlung abzuschließen.',
  v3RestAssuredFastDeliveryAfterPayment:
    'Das Item wird dir zugesandt, sobald das Zahlungsergebnis eingegangen ist.',
  v3SaveOrderInfoForProgress:
    'Du kannst einen Screenshot der Bestellinformationen machen, um den Verlauf der Transaktion zu verfolgen.',
  v3PaymentCompleted: 'Die Zahlung wurde abgeschlossen.',
  v3AddToHomeScreen: 'Zum Startbildschirm hinzufügen',
  v3AddShortcutForBonus:
    'Eine Verknüpfung hinzufügen, um zusätzliche Belohnungen zu erhalten.',
  v3ShareSuccess: 'Geteilt',
  v3ShareFailure: 'Teilen fehlgeschlagen.',
  v3RewardClaimed: 'Belohnung abgeholt',
  v3RewardClaimFailed: 'Belohnung nicht abgeholt.',
  v3EventNotStarted: 'Event hat noch nicht begonnen.',
  v3EventEnded: 'Event ist beendet.',
  v3ClickSelectCoupon: 'Klicken Sie, um den Gutschein auszuwählen',
  v3CouponsRecommendedUsed: 'Empfohlenen Gutschein verwendet',
  v3CouponsSelected: 'Ausgewählten Gutschein',
  v3NoCouponsAvaliable: 'Keine verfügbaren Gutscheine',
  v3SupplementStatus: 'Status',
  v3SupplementNormal: 'Normal',
  v3SupplementBanned: 'Gesperrt',
  v3SupplementPendingPayment: 'Ausstehende Zahlung',
  v3SupplementSwitchCharacter: 'Charakter wechseln',
  v3SupplementAccountInfoInvalid: 'Kontoinformationen ungültig',
  v3SupplementContactGSForTopUpLink:
    'Bitte kontaktieren Sie GS für den Aufladungslink',
  v3SupplementTopUpCompleted: 'Aufladung abgeschlossen:',
  v3SupplementTotalRefundOrders: 'Insgesamt {} Rückerstattungsaufträge',
  v3SupplementPendingSupplementAmount: 'Ausstehender Zahlungsbetrag:',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'Konto/Charakter normal, keine Zahlung erforderlich',
  v3SupplementEnjoyYourGame: 'Viel Spaß beim Spielen!',
  v3SupplementOrderInformation: 'Bestellinformationen',
  v3SupplementPendingPaymentAmount: 'Ausstehender Zahlungsbetrag:',
  v3LookUpCouponRule: 'Coupon-Verteilungsregeln prüfen',
  v3SwitchOldVersion: 'Zu alter Zahlungsplattform wechseln',
  v3FirstTopUpGiveaway: '1. Aufladebonus',
  v3SecureConnection: 'Sichere Verbindung wird hergestellt',
  v3RequestTimeOut: 'Ladevorgang abgelaufen, bitte versuche es später erneut.',
  v3ConfirmLeave: 'Beenden?',
  v3NoSubmitOrder:
    'Dein Warenkorb wurde noch nicht abgeschlossen. Wenn du jetzt gehst, kannst du deine gewünschten Items verpassen.',
  v3ContinueSubmit: 'Fortfahren',
  v3LeaveSubmit: 'Verlassen',
  v3RecentBug: 'Kürzliche Käufe',
  v3PwaTapShareOrMenuIcon: 'Tippen Sie in der Browser-Symbolleiste auf das Symbol „Teilen" oder „Menü"',
  v3PwaFindAndTapAddToHomeScreen: 'Suchen und tippen Sie in den Optionen auf „Zum Startbildschirm zufügen"'
};
